import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  DecimalScale,
  Form,
  FormDialogMode,
  FormOptions,
  FormSkeleton,
  Section,
  SelectOption,
  SortDirection,
  useNotify,
  UserPermission
} from '@globaleris/ui.library'
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Paper,
  Typography
} from '@material-ui/core'
// import { AssignmentInd } from '@material-ui/icons';
import { AssignmentLate, Block, Delete, Edit } from '@material-ui/icons'
import i18next from 'i18next'
import moment from 'moment'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  EnumEstadoProductoCapacidad,
  EnumServicio,
  EnumTipoPeaje,
  EnumTipoProductoCapacidad,
  EnumTipoSujeto
} from '../../../api'
import { EnumCommodity } from '../../../api/Argentia/enums'
import {
  ActivityTypeModel,
  ContractModel,
  DistributorModel,
  TollModel
} from '../../../api/Argentia/model/contracts'
import { EnumTipoContratoATR } from '../../../api/oData/enums/enumTipoContratoATR'
import ButtonWithPermissions from '../../../components/buttonWithPermissions/buttonWithPermissions'
import Page, { PageLayout } from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { BreadcrumbLink } from '../../../components/shared/breadcrumbLink/breadcrumbLink'
import {
  DATE_FORMATS,
  DEFAULT_DATE_FORMAT
} from '../../../components/shared/priceExpressionValidator/components/dateInput'
import {
  enumEnumToValueNumber,
  enumToSelectOptionArray,
  generateUniqueKeyWithNoPrefix,
  toLocaleDate
} from '../../../helpers'
import { associateActionIcon } from '../../../helpers/dataTableActionIconHelper'
import { getVersionNumberFromArray } from '../../../helpers/getVersionNumberFromArray'
import { getUserPermissions, hasPermission, hasResource } from '../../../helpers/permissionsHelper'
import {
  missingFieldsForm,
  missingFieldsFormWithRequiredText
} from '../../../helpers/validateFormHelper'
import {
  FormDialogDefinitionProps,
  useConfirmationDialog,
  useFormDialog,
  useHttpError
} from '../../../hooks'
import { useShowGoToProcedures } from '../../../hooks/useShowGoToProceduresDialog'
import { ActionIcons, GlobalNotification, NonAuthRoutes } from '../../../model'
import { InformationDialogs } from '../../../model/enums/informationDialogs'
import { Pages, Resources } from '../../../model/RBAC/constants'
import { SearchSelectOption } from '../../../model/searchSelectOption'
import {
  addNewItemTempList,
  getCustomerDomain,
  notifyError,
  removeOrMarkProductTempList,
  updateTempList
} from '../../../redux'
import { selectClientData } from '../../../redux/selectors/client.selectors'
import { getLinkClientText, SubjectProps } from '../../clients/client.helper'
import {
  fetchPostalCodes,
  fetchSubjectsByTypeAndCommodity,
  getPostalAddressByID
} from '../../clients/client.service'
import { ProcedureFormMode } from '../../procedures/procedures.types'
import {
  canEditATR,
  capacityModelListToFormModelMapper,
  consolidateATRState,
  contractATRFormToPatchPowerModelMapper,
  contractATRFormToPostContractATRDetail,
  contractATRFormToPostPower,
  contractCapacitiesMapper,
  contractModelToATRMapper,
  cupsCNAEMapper,
  cupsModelToFormModelMapper,
  getDiffContractDetailATR,
  getLatestVersion,
  listCnaeItemMapper,
  listDistributorItemMapper,
  listTollItemMapper,
  mapAddVersionToTableModel,
  mapATRVersionsToTableModel,
  mapATRVersionTableToContractDetails,
  mapATRVersionToTableModel,
  mapDbContractDetails,
  mapUpdateVersionToTableModel,
  newCapacityFormModelConsolidate,
  updateContractATRSuppliesBatchMapper,
  updateContractCapacitiesSuppliesBatchMapper,
  versionIsCurrentOrFuture
} from '../contracts.mapper'
import {
  CapacityEditFormDialogValidations,
  CapacityFormModel,
  CapacityInitialValues,
  ContractATRAddVersionFormModel,
  ContractATRFormModel,
  ContractSuppliesFormValidations,
  CupsFormModel,
  DBContractSuppliesProps,
  PatchContractATRDetail,
  PatchContractSuppliesBatchRequest,
  PatchPower,
  RulebookContractSuppliesValidations,
  RulebookContractsValidations
} from '../contracts.model'
import {
  fetchActivityTypes,
  fetchCUPSByCode,
  fetchPowerPeriodsByToll,
  fetchPressureGroup,
  fetchServices,
  fetchTolls,
  getContractDetails,
  updateContractSupplies
} from '../contracts.service'
import { ATRVersionTableModel, VersionsTable } from './components/versionsTable'
import { ConfirmationDialogs } from '../../../model/enums/confirmationDialogs'
interface ContractDetailsPageProps {
  location: { state: { contractID: number; contract: ContractModel } }
}

interface PeriodsFormConfig {
  1: boolean
  2: boolean
  3: boolean
  4: boolean
  5: boolean
  6: boolean
}

const initialPeriodsFormConfig = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false
}

const initialCapacityValidations: CapacityEditFormDialogValidations = {
  isDirty: false,
  startDate: true,
  endDate: true,
  startDateContract: true,
  endDateContract: true
}

const initialValidations: ContractSuppliesFormValidations = {
  isDirty: false,
  startDate: true,
  endDate: true,
  signDate: true,
  contractCode: true,
  iban: true,
  postalCode: true,
  cupsCode: true,
  newStartDate: true,
  newEndDate: true,
  startDateContract: true,
  endDateContract: true,
  newStartDateContract: true,
  newEndDateContract: true,
  newStartDatePast: true
}

export const ContractDetailsPage: React.FC<ContractDetailsPageProps> = props => {
  const history = useHistory()
  const [globalNotification, setGlobalNotification] = useState<GlobalNotification | undefined>(
    undefined
  )
  const { info, error } = useNotify()
  const { errorProps } = useHttpError()
  const {
    openForm,
    updateFormDefinition,
    updateFormData,
    closeForm,
    formProps,
    formHookProps,
    getFormData,
    CustomFormDialog
  } = useFormDialog()

  const { getInformation, getConfirmation, closeConfirmation, closeInformation } =
    useConfirmationDialog()
  const { getShowGoToProceduresDialog } = useShowGoToProcedures()

  const [t] = useTranslation(['contracts', 'globalerisLibrary', 'enums', 'informationDialogs'])
  const contractID = props.location.state.contractID
  const contract = props.location.state.contract

  const [contractDetails, setContractDetails] = useState<ContractModel | undefined>(undefined)
  const [dbContractDetails, setDbContractDetails] = useState<DBContractSuppliesProps>({
    cups: null,
    contractATR: null,
    capacities: null
  }) // used only for comparison purposes
  const [cups, setCups] = useState<Partial<CupsFormModel>>({})
  const [tempCapacities, setCapacities] = useState<CapacityFormModel[]>([])
  const [contractATR, setContractATR] = useState<Partial<ContractATRFormModel> | null>(null)
  const [currentATR, setCurrentATR] = useState<Partial<ContractATRFormModel> | null>(null)
  const [atrVersions, setAtrVersions] = useState<ATRVersionTableModel[] | null>(null)
  const [contractATRDetails, setContractATRDetails] = useState<PatchContractATRDetail[]>([])
  const [powers, setPowers] = useState<PatchPower[]>([])

  const [pressureGroup, setPressureGroup] = useState<number | undefined>()
  const [periodsFormConfig, setPeriodsFormConfig] =
    useState<PeriodsFormConfig>(initialPeriodsFormConfig)
  const [periodsVersionFormConfig, setPeriodsVersionFormConfig] =
    useState<PeriodsFormConfig>(initialPeriodsFormConfig) //state for modal Form Management
  const [formMode, setFormMode] = useState<FormDialogMode | null>(null) //state for modal Form Management

  const [qaRequired, setQaRequired] = useState<boolean>(false)
  const [qdRequired, setQdRequired] = useState<boolean>(false)
  const [startDateHelpText, setStartDateHelpText] = useState<string | undefined>()

  const [validations, setValidations] =
    useState<ContractSuppliesFormValidations>(initialValidations)
  const [cnaeList, setCnaeList] = useState<ActivityTypeModel[]>([])
  const [pressureGroupList, setPressureGroupList] = useState<SelectOption[]>([])
  const [distributorList, setDistributorList] = useState<DistributorModel[]>([])
  const [tollList, setTollList] = useState<TollModel[]>([])
  const [servicesList, setServicesList] = useState<SelectOption[]>([])
  const [intraDay, setIntraDay] = useState<boolean>(false)

  const [pendingChanges, setPendingChanges] = useState<boolean>(false)
  const [canChangeATRState, setCanChangeATRState] = useState<boolean>(true)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true)
  const [isFetchingDistributor, setIsFetchingDistributor] = useState<boolean>(false)
  const [isFetchingPressure, setIsFetchingPressure] = useState<boolean>(false)
  const [isFetchingCnae, setIsFetchingCnae] = useState<boolean>(false)
  const [isFetchingTolls, setIsFetchingTolls] = useState<boolean>(false)
  const [validationsDialog, setValidationsDialog] = useState<CapacityEditFormDialogValidations>(
    initialCapacityValidations
  )
  const [showVersionsTable, setShowVersionsTable] = useState<boolean>(false)

  const [initialPostalCode, setInitialPostalCode] = useState<string | null>(null)
  const [cupsCodeErrorKey, setCupsCodeErrorKey] = useState<
    'cupsCode' | 'cupsCodeRequired' | 'cupsCodeLength'
  >('cupsCode')

  const tableCardRef = useRef<HTMLDivElement | null>(null)
  const cupsSuppliesFormRef = useRef<HTMLDivElement | null>(null)

  const clientData = useSelector(selectClientData)
  const commodity =
    enumEnumToValueNumber(EnumCommodity, contract.commodity) ??
    cups.commodity ??
    contractDetails?.commodity ??
    1

  if (!contractID) {
    history.goBack()
  }

  const updateVersionsCanEdit = (newState: EnumEstadoProductoCapacidad) => {
    if (atrVersions) {
      const updatedVersions = atrVersions.map(version => ({
        ...version,
        canEdit: canEditATR(newState)
      }))
      setAtrVersions(updatedVersions)
    }
  }

  const canInsertVersion = useMemo(() => {
    const state = currentATR?.state
    return (
      state === EnumEstadoProductoCapacidad.Activo ||
      state === EnumEstadoProductoCapacidad.Borrador ||
      state === EnumEstadoProductoCapacidad.Rechazada
    )
  }, [currentATR?.state])

  const hasFutureVersion = (): boolean => {
    if (!atrVersions) return false
    return atrVersions.some(
      version => version.startDate && moment(version.startDate).isAfter(moment(), 'day')
    )
  }

  const latestVersionHasPastStartDate = (): boolean => {
    if (!atrVersions || atrVersions.length === 0) return false

    const activeVersions = atrVersions.filter(version => {
      const isMarkedForDelete = contractATRDetails.some(
        detail => detail.id === version.idDetail && detail.delete === true
      )
      return !isMarkedForDelete
    })

    if (activeVersions.length === 0) return false

    const latestVersion = activeVersions.reduce((latest, current) => {
      const latestVersionNum = latest.version[0] ?? 0
      const currentVersionNum = current.version[0] ?? 0
      return currentVersionNum > latestVersionNum ? current : latest
    })

    return latestVersion.startDate && moment(latestVersion.startDate).isBefore(moment(), 'day')
  }

  const capacitiesActions = (cap: CapacityFormModel[]): CapacityFormModel[] => {
    if (cap) {
      return cap.map(p => {
        const actionIcon = p.delete
          ? associateActionIcon(
              p,
              ActionIcons.DELETE_ITEM,
              t('contracts:components.capacitiesTable.actionsIcons.pendingDelete')
            )
          : p.tempId
            ? associateActionIcon(
                p,
                ActionIcons.NEW_ITEM,
                t('contracts:components.capacitiesTable.actionsIcons.pendingSave')
              )
            : undefined
        return { ...p, actions: actionIcon }
      })
    }
    return cap
  }

  const capacities = capacitiesActions(tempCapacities)

  const handleFormDirty = (
    validation: RulebookContractsValidations | RulebookContractSuppliesValidations,
    valid: boolean,
    cause?: string
  ) => {
    setValidations(prevValidations => {
      const newValidation = { ...prevValidations, [validation]: valid }
      const isDirty = !(
        newValidation.signDate &&
        newValidation.contractCode &&
        newValidation.iban &&
        newValidation.postalCode &&
        newValidation.cupsCode &&
        newValidation.newStartDate &&
        newValidation.newEndDate &&
        newValidation.newStartDateContract &&
        newValidation.newStartDatePast &&
        newValidation.newEndDateContract &&
        newValidation.startDate &&
        newValidation.endDate &&
        newValidation.startDateContract &&
        newValidation.endDateContract
      )
      return { ...newValidation, isDirty: isDirty }
    })
  }

  const validateNewStartDateATR = (
    startDate?: Date,
    endDate?: Date | null,
    state?: EnumEstadoProductoCapacidad | undefined
  ) => {
    // Validación: fecha inicio a futuro si el estado es Activo
    if (
      state === EnumEstadoProductoCapacidad.Activo &&
      startDate &&
      moment(startDate).isBefore(moment(), 'day')
    ) {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_PAST, false)
      return
    } else {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_PAST, true)
    }

    if (endDate && startDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE, false)
      return
    } else if (
      startDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(startDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_CONTRACT, true)
      handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE, true)
    }
  }

  const validateNewEndDateATR = (startDate?: Date, endDate?: Date | null) => {
    if (startDate && endDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE, false)
    } else if (
      endDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(endDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE_CONTRACT, true)
      handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE, true)
    }
  }

  const validateStartDateATR = (startDate?: Date, endDate?: Date | null) => {
    if (endDate && startDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirty(RulebookContractSuppliesValidations.START_DATE, false)
      return
    } else if (
      startDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(startDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirty(RulebookContractSuppliesValidations.START_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirty(RulebookContractSuppliesValidations.START_DATE_CONTRACT, true)
      handleFormDirty(RulebookContractSuppliesValidations.START_DATE, true)
    }
  }

  const validateEndDateATR = (startDate?: Date, endDate?: Date | null) => {
    if (startDate && endDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirty(RulebookContractSuppliesValidations.END_DATE, false)
    } else if (
      endDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(endDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirty(RulebookContractSuppliesValidations.END_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirty(RulebookContractSuppliesValidations.END_DATE_CONTRACT, true)
      handleFormDirty(RulebookContractSuppliesValidations.END_DATE, true)
    }
  }

  const resetAddVersionATRValidations = () => {
    handleFormDirty(RulebookContractSuppliesValidations.START_DATE, true)
    handleFormDirty(RulebookContractSuppliesValidations.START_DATE_CONTRACT, true)
    handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_PAST, true)
    handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE, true)
    handleFormDirty(RulebookContractSuppliesValidations.NEW_START_DATE_CONTRACT, true)
    handleFormDirty(RulebookContractSuppliesValidations.END_DATE, true)
    handleFormDirty(RulebookContractSuppliesValidations.END_DATE_CONTRACT, true)
    handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE, true)
    handleFormDirty(RulebookContractSuppliesValidations.NEW_END_DATE_CONTRACT, true)
  }

  const handleFormDirtyDialog = (
    validation: 'startDate' | 'endDate' | 'startDateContract' | 'endDateContract',
    valid: boolean
  ) => {
    setValidationsDialog(prevValidations => {
      const newValidation = { ...prevValidations, [validation]: valid }
      const isDirty = !(
        newValidation.startDate &&
        newValidation.endDate &&
        newValidation.startDateContract &&
        newValidation.endDateContract
      )
      return { ...newValidation, isDirty: isDirty }
    })
  }

  const validateStartDateCapacityDialog = (startDate?: Date, endDate?: Date) => {
    if (endDate && startDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.START_DATE, false)
      return
    } else if (
      startDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(startDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.START_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.START_DATE, true)
      handleFormDirtyDialog(RulebookContractSuppliesValidations.END_DATE, true)
      handleFormDirtyDialog(RulebookContractSuppliesValidations.START_DATE_CONTRACT, true)
    }
  }

  const validateEndDateCapacityDialog = (startDate?: Date, endDate?: Date) => {
    if (startDate && endDate && moment(endDate).isBefore(moment(startDate), 'days')) {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.END_DATE, false)
      return
    } else if (
      endDate &&
      contractDetails?.startDate &&
      contractDetails?.endDate &&
      !moment(endDate).isBetween(contractDetails.startDate, contractDetails.endDate, 'days', '[]')
    ) {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.END_DATE_CONTRACT, false)
      return
    } else {
      handleFormDirtyDialog(RulebookContractSuppliesValidations.START_DATE, true)
      handleFormDirtyDialog(RulebookContractSuppliesValidations.END_DATE, true)
      handleFormDirtyDialog(RulebookContractSuppliesValidations.END_DATE_CONTRACT, true)
    }
  }

  const getInitialValues = (): CapacityInitialValues => {
    const codeValue = getContractCodeVersion()
    const initialValues = getLatestCapacityValue()
    return {
      initialCode: codeValue,
      initialToll: initialValues && initialValues.tollValue,
      initialQaEstimada: initialValues && initialValues.qaEstimadaValue
    }
  }

  const getLatestCapacityValue = (): { tollValue: number; qaEstimadaValue: number } | undefined => {
    let latestCapacity: CapacityFormModel | undefined

    if (tempCapacities.length > 0) {
      if (tempCapacities.some(c => c.timeStamp !== undefined)) {
        for (const c of tempCapacities) {
          if (
            c.timeStamp !== undefined &&
            (latestCapacity === undefined || c.timeStamp > (latestCapacity.timeStamp ?? 0))
          ) {
            latestCapacity = c
          }
        }
      } else {
        for (const c of tempCapacities) {
          if (
            c.id !== undefined &&
            (latestCapacity === undefined || c.id > (latestCapacity.id ?? 0))
          ) {
            latestCapacity = c
          }
        }
      }
    }

    if (latestCapacity) {
      return { tollValue: latestCapacity.toll, qaEstimadaValue: latestCapacity.qaEstimada }
    }

    return undefined
  }

  const getContractCodeVersion = () => {
    if (contractDetails?.contractCode) {
      return getVersionNumberFromArray(
        tempCapacities,
        'code',
        contractDetails?.contractCode,
        'underscore'
      )
    }
  }

  const getDetails = async contractID => {
    setIsFetching(true)
    const response = await getContractDetails(contractID)
    if (response.success && response.data) {
      const contract = response.data
      setContractDetails(contract)
      setDbContractDetails(mapDbContractDetails(contract))
      if (contract.capacities && contract.capacities.length > 0) {
        setCapacities(capacityModelListToFormModelMapper(contract.capacities))
      } else if (contract.contractATR) {
        const dbContractATRMapped = contractModelToATRMapper(contract.contractATR)
        setContractATR(dbContractATRMapped)
        setCurrentATR(dbContractATRMapped)
        setAtrVersions(
          mapATRVersionsToTableModel(contract.contractATR?.versions, contract.contractATR?.state)
        )
        configureATRForm(dbContractATRMapped)
      }
      if (contract.cupsList && contract.cupsList.length > 0) {
        const cups = contract.cupsList[0]
        setCups(cupsModelToFormModelMapper(cups, cnaeList))
        setInitialPostalCode(cups.fiscalAddress?.postalCode ?? '')
        setPressureGroup(contract.cupsList[0].pressureGroupId)
      }

      // Esperar a que todas las fetches asíncronas terminen
      await Promise.all([
        !distributorList.length && contract
          ? getDistributors(commodity ?? cups.commodity)
          : Promise.resolve(),
        !cnaeList.length ? getActivityTypes() : Promise.resolve(),
        !pressureGroupList.length && contract
          ? getPressureGroup(commodity ?? cups.commodity)
          : Promise.resolve(),
        !tollList.length && contract ? getTolls(commodity ?? cups.commodity) : Promise.resolve(),
        !servicesList.length
          ? getServices(
              clientData && clientData?.type ? clientData?.type : EnumTipoSujeto.ClienteFinal
            )
          : Promise.resolve()
      ])

      // Desactivar bandera de carga inicial - los onChange con validación de cambio real prevendrán activaciones falsas
      setIsInitialLoad(false)
    } else {
      error(t('contracts:notifications.errors.noCups'))
      history.goBack()
    }
    setIsFetching(false)
  }

  const requestHadNewCapacity = (request: PatchContractSuppliesBatchRequest): boolean => {
    if (request.capacities && request.capacities.length > 0) {
      return request.capacities.some(cap => !cap.id)
    }
    return false
  }

  const getNewCapacityCode = (request: PatchContractSuppliesBatchRequest): string => {
    const newCapacity = request.capacities?.find(cap => !cap.id)
    return newCapacity?.code ?? ''
  }

  const getNewCapacityStartDate = (request: PatchContractSuppliesBatchRequest): string => {
    const newCapacity = request.capacities?.find(cap => !cap.id)
    return newCapacity?.startDate ?? ''
  }

  const defineTollSelectOptionList = (pressureGroupParam?: number) => {
    if (pressureGroupParam) {
      return listTollItemMapper(
        tollList!.filter(x => x.pressureGroupList.findIndex(x => x === pressureGroupParam) > -1)
      )
    } else {
      return listTollItemMapper(tollList!)
    }
  }

  const onSave = async () => {
    let resp = {
      success: false,
      contractID: 0
    }
    if (
      !isSaving &&
      cups &&
      dbContractDetails &&
      (contractATR || (tempCapacities && tempCapacities.length > 0))
    ) {
      if (missingFieldsForm(cupsSection, cups)) {
        notifyError(t('contracts:notifications.create.errorInvalidForm'))
      } else {
        setIsSaving(true)
        const contractATRForm =
          contractATR && commodity === EnumCommodity.Electricidad
            ? consolidateATRState(contractATR as ContractATRFormModel)
            : null
        const newData = {
          cups: cups as CupsFormModel,
          contractATR: contractATRForm,
          capacities: tempCapacities as CapacityFormModel[]
        }
        const oldData = {
          cups: dbContractDetails.cups as CupsFormModel,
          contractATR: dbContractDetails.contractATR as ContractATRFormModel,
          capacities: dbContractDetails.capacities as CapacityFormModel[]
        }
        let request: PatchContractSuppliesBatchRequest

        if (commodity === EnumCommodity.Electricidad) {
          request = {
            ...updateContractATRSuppliesBatchMapper(newData, oldData),
            contractATRDetails: contractATRDetails,
            powers: powers
          }
        } else {
          request = {
            ...updateContractCapacitiesSuppliesBatchMapper(newData, oldData)
          }
        }

        const resetAndRefresh = async () => {
          setCanChangeATRState(false)
          setPendingChanges(false)
          resetAddVersionATRValidations()
          setPowers([])
          setContractATRDetails([])
          setIsInitialLoad(true) // Activar bandera antes de recargar
          await getDetails(contractID)
        }

        await updateContractSupplies(request).then(response => {
          if (response.success) {
            info(t('contracts:notifications.edition.success'))

            if (
              hasResource(Resources.ComunicationsCenterProcedures) &&
              commodity === EnumCommodity.Electricidad &&
              !latestVersionHasPastStartDate() &&
              contractATR?.state === EnumEstadoProductoCapacidad.Borrador
            ) {
              getShowGoToProceduresDialog({
                contractID: contractID,
                origin: ProcedureFormMode.CAMBIO_CONTRATO_ATR
              })
            } else if (
              hasResource(Resources.ComunicationsCenterProcedures) &&
              commodity === EnumCommodity.GasNatural &&
              requestHadNewCapacity(request)
            ) {
              getShowGoToProceduresDialog({
                contractID: contractID,
                capacityCode: getNewCapacityCode(request),
                origin: ProcedureFormMode.ALTA_CAPACIDAD,
                cancelAction: () =>
                  history.push(NonAuthRoutes.ClientFile, {
                    clientID: clientData?.id
                  }),
                capacityStartDate: getNewCapacityStartDate(request)
              })
            }
            resetAndRefresh()
          } else {
            notifyError(response.error?.message ?? t('contracts:notifications.edition.error'))
          }
          setIsSaving(false)
        })
      }
    }
    return resp
  }

  const capacityAddDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'ADD',
        sections: [
          {
            inputs: [
              {
                name: 'code',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.code'),
                type: DataType.TEXT,
                required: true,
                onBlur: (newCode: any) => {
                  newCode && updateFormData(prevState => ({ ...prevState, code: newCode }))
                }
              },
              {
                name: 'type',
                label: t(
                  'contracts:components.capacitiesTable.actions.edit.inputs.contractCapacityType'
                ),
                type: DataType.SELECT,
                selectOptions: enumToSelectOptionArray(
                  EnumTipoProductoCapacidad,
                  'enums:EnumTipoProductoCapacidad'
                ),
                required: true,
                onChange(value, formState) {
                  const isIntraday = +value === EnumTipoProductoCapacidad.Intradiario
                  const isDaily = +value === EnumTipoProductoCapacidad.Diario
                  isIntraday ? setIntraDay(true) : setIntraDay(false)
                  updateFormData(prevState => ({
                    ...prevState,
                    type: +value,
                    startDate: isIntraday
                      ? moment().format('YYYY-MM-DD')
                      : isDaily
                        ? moment().add(1, 'day').format('YYYY-MM-DD')
                        : contractDetails?.startDate,
                    endDate: isIntraday
                      ? moment().format('YYYY-MM-DD')
                      : isDaily
                        ? moment().add(1, 'day').format('YYYY-MM-DD')
                        : contractDetails?.endDate,
                    nmHours: isIntraday
                      ? prevState.nmHours
                      : 0 /* Remove nmHours if type is changed */
                  }))
                }
              },
              {
                name: 'toll',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
                type: DataType.SELECT,
                selectOptions: defineTollSelectOptionList(pressureGroup),
                required: true,
                onChange: (value, formState: any) => {
                  setRequiredByToll(value)
                }
              },
              {
                name: 'contractType',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.service'),
                type: DataType.SELECT,
                selectOptions: servicesList,
                required: true
              },
              {
                name: 'qaEstimada',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.qa'),
                suffix: t('contracts:forms.add.units.kWh'),
                type: DataType.NUMBER,
                customDecimalScale: 0,
                required: qaRequired
              },
              {
                name: 'qdContratada',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.qd'),
                suffix: t('contracts:forms.add.units.kWh'),
                type: DataType.NUMBER,
                required: qdRequired
              },
              {
                name: 'startDate',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.startDate'),
                type: DataType.DATE,
                required: true,
                errorState: !validationsDialog.startDate || !validationsDialog.startDateContract,
                errorText: !validationsDialog.startDateContract
                  ? t('contracts:notifications.errors.startDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.startDate'),
                onChange: (newStartDate: any, formState: any) => {
                  validateStartDateCapacityDialog(newStartDate, formState.endDate)
                  validateEndDateCapacityDialog(newStartDate, formState.endDate)
                }
              },
              {
                name: 'endDate',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.endDate'),
                type: DataType.DATE,
                required: true,
                errorState: !validationsDialog.endDate || !validationsDialog.endDateContract,
                errorText: !validationsDialog.endDateContract
                  ? t('contracts:notifications.errors.endDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.endDate'),
                onChange: (newEndDate: any, formState: any) => {
                  validateStartDateCapacityDialog(formState.startDate, newEndDate)
                  validateEndDateCapacityDialog(formState.startDate, newEndDate)
                }
              },
              {
                name: 'nmHours',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.nmHours'),
                type: DataType.NUMBER,
                decimalScale: DecimalScale.VOLUME /* No decimals allowed */,
                display: intraDay
              }
            ]
          }
        ]
      }
    }, [
      validationsDialog.startDate,
      validationsDialog.endDate,
      validationsDialog.startDateContract,
      validationsDialog.endDateContract,
      tollList,
      servicesList,
      pressureGroup,
      intraDay,
      qaRequired,
      qdRequired
    ])

  const capacityEditDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'EDIT',
        sections: [
          {
            inputs: [
              {
                name: 'code',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.code'),
                type: DataType.TEXT,
                required: true,
                onBlur: (newCode: any) => {
                  newCode && updateFormData(prevState => ({ ...prevState, code: newCode }))
                }
              },
              {
                name: 'type',
                label: t(
                  'contracts:components.capacitiesTable.actions.edit.inputs.contractCapacityType'
                ),
                type: DataType.SELECT,
                selectOptions: enumToSelectOptionArray(
                  EnumTipoProductoCapacidad,
                  'enums:EnumTipoProductoCapacidad'
                ),
                required: true,
                onChange(value, formState) {
                  const isIntraday = +value === EnumTipoProductoCapacidad.Intradiario
                  isIntraday ? setIntraDay(true) : setIntraDay(false)
                  updateFormData(prevState => ({
                    ...prevState,
                    type: +value,
                    nmHours: isIntraday
                      ? prevState.nmHours
                      : 0 /* Remove nmHours if type is changed */
                  }))
                }
              },
              {
                name: 'toll',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
                type: DataType.SELECT,
                selectOptions: defineTollSelectOptionList(pressureGroup),
                helpText: t('contracts:forms.edit.helpText.modRequest'),
                required: true,
                onChange: (value, formState: any) => {
                  setRequiredByToll(value)
                }
              },
              {
                name: 'contractType',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.service'),
                type: DataType.SELECT,
                selectOptions: servicesList,
                required: true
              },
              {
                name: 'qaEstimada',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.qa'),
                suffix: t('contracts:forms.add.units.kWh'),
                type: DataType.NUMBER,
                customDecimalScale: 0,
                required: qaRequired
              },
              {
                name: 'qdContratada',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.qd'),
                suffix: t('contracts:forms.add.units.kWh'),
                helpText: t('contracts:forms.edit.helpText.modRequest'),
                type: DataType.NUMBER,
                required: qdRequired
              },
              {
                name: 'startDate',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.startDate'),
                type: DataType.DATE,
                required: true,
                errorState: !validationsDialog.startDate || !validationsDialog.startDateContract,
                errorText: !validationsDialog.startDateContract
                  ? t('contracts:notifications.errors.startDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.startDate'),
                onChange: (newStartDate: any, formState: any) => {
                  validateStartDateCapacityDialog(newStartDate, formState.endDate)
                  validateEndDateCapacityDialog(newStartDate, formState.endDate)
                }
              },
              {
                name: 'endDate',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.endDate'),
                type: DataType.DATE,
                required: true,
                errorState: !validationsDialog.endDate || !validationsDialog.endDateContract,
                errorText: !validationsDialog.endDateContract
                  ? t('contracts:notifications.errors.endDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.endDate'),
                onChange: (newEndDate: any, formState: any) => {
                  validateStartDateCapacityDialog(formState.startDate, newEndDate)
                  validateEndDateCapacityDialog(formState.startDate, newEndDate)
                }
              },
              {
                name: 'status',
                label: t('contracts:components.capacitiesTable.columns.status'),
                type: DataType.SELECT,
                selectOptions: enumToSelectOptionArray(
                  EnumEstadoProductoCapacidad,
                  'enums:EnumEstadoProductoCapacidad'
                )
              },
              {
                name: 'nmHours',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.nmHours'),
                type: DataType.NUMBER,
                display: intraDay,
                decimalScale: DecimalScale.VOLUME // No decimals allowed
              }
            ]
          }
        ]
      }
    }, [
      validationsDialog.startDate,
      validationsDialog.endDate,
      validationsDialog.startDateContract,
      validationsDialog.endDateContract,
      tollList,
      servicesList,
      pressureGroup,
      intraDay,
      qaRequired,
      qdRequired
    ])

  const atrVersionFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'ADD_ATR',
        sections: [
          {
            inputs: [
              {
                name: 'code',
                label: t('contracts:forms.details.inputs.ATRCode'),
                type: DataType.TEXT,
                inputSize: 4,
                required: true,
                readOnly: formMode !== FormDialogMode.EDIT,
                helpText:
                  formMode === FormDialogMode.EDIT
                    ? t('contracts:forms.details.helpText.modRequest')
                    : undefined
              },
              {
                name: 'type',
                label: t('contracts:forms.details.inputs.ATRType'),
                type: DataType.SELECT,
                inputSize: 4,
                selectOptions: enumToSelectOptionArray(
                  EnumTipoContratoATR,
                  'enums:EnumTipoContratoATR'
                ),
                readOnly: formMode !== FormDialogMode.EDIT
              },
              {
                name: 'state',
                label: t('contracts:forms.details.inputs.status'),
                type: DataType.SELECT,
                inputSize: 4,
                selectOptions: enumToSelectOptionArray(
                  EnumEstadoProductoCapacidad,
                  'enums:EnumEstadoProductoCapacidad'
                ),
                readOnly: true
              },
              {
                name: 'startDate',
                label:
                  formMode === FormDialogMode.ADD
                    ? t('contracts:forms.details.inputs.latestStartDate')
                    : t('contracts:forms.details.inputs.startDate'),
                type: DataType.DATE,
                readOnly: formMode === FormDialogMode.ADD,
                // helpText: !validations.isDirty ? startDateHelpText : undefined,
                errorState: !validations.startDate || !validations.startDateContract,
                errorText: !validations.startDateContract
                  ? t('contracts:notifications.errors.startDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.startDate'),
                onChange: (newStartDate: any, formState: any) => {
                  const formContractDetails = formState as ContractATRFormModel
                  !isInitialLoad && setPendingChanges(true)
                  validateStartDateATR(newStartDate, formContractDetails?.endDate)
                  validateEndDateATR(newStartDate, formContractDetails?.endDate)
                  // updateStartDateHelpText(formContractDetails)
                }
              },
              {
                name: 'endDate',
                label:
                  formMode === FormDialogMode.ADD
                    ? t('contracts:forms.details.inputs.latestEndDate')
                    : t('contracts:forms.details.inputs.endDate'),
                type: DataType.DATE,
                readOnly: formMode === FormDialogMode.ADD,
                errorState: !validations.endDate || !validations.endDateContract,
                errorText: !validations.endDateContract
                  ? t('contracts:notifications.errors.startDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.startDate'),
                onChange: (newEndDate: any, formState: any) => {
                  const formContractDetails = formState as ContractATRFormModel
                  !isInitialLoad && setPendingChanges(true)
                  validateStartDateATR(formContractDetails?.startDate, newEndDate)
                  validateEndDateATR(formContractDetails?.startDate, newEndDate)
                  // updateStartDateHelpText(formContractDetails)
                }
              },
              {
                name: 'newStartDate',
                label: t('contracts:forms.details.inputs.dateNewVersion'),
                type: DataType.DATE,
                required: true,
                display: formMode !== FormDialogMode.EDIT,
                errorState:
                  !validations.newStartDatePast ||
                  !validations.newStartDate ||
                  !validations.newStartDateContract,
                errorText: !validations.newStartDatePast
                  ? t('contracts:notifications.errors.newStartDatePast')
                  : !validations.newStartDateContract
                    ? t('contracts:notifications.errors.startDateContract', {
                        startDateContract: moment(contractDetails?.startDate).format(
                          DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                        ),
                        endDateContract: moment(contractDetails?.endDate).format(
                          DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                        )
                      })
                    : t('contracts:notifications.errors.startDate'),
                onChange: (newValue: any, formState) => {
                  const contractATRDetails = formState as ContractATRFormModel
                  validateNewStartDateATR(
                    newValue,
                    contractATRDetails.newEndDate,
                    contractATRDetails.state
                  )
                  validateNewEndDateATR(newValue, contractATRDetails.newEndDate)
                  const updateOldEndDate = moment(newValue).add(-1, 'days').toDate()
                  validateEndDateATR(contractATRDetails.startDate, updateOldEndDate)
                  newValue &&
                    updateFormData(prevState => ({
                      ...prevState,
                      endDate: updateOldEndDate
                    }))
                }
              },
              {
                name: 'newEndDate',
                label: t('contracts:forms.details.inputs.dateNewEndVersion'),
                type: DataType.DATE,
                required: true,
                display: formMode !== FormDialogMode.EDIT,
                errorState: !validations.newEndDate || !validations.newEndDateContract,
                errorText: !validations.newEndDateContract
                  ? t('contracts:notifications.errors.endDateContract', {
                      startDateContract: moment(contractDetails?.startDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      ),
                      endDateContract: moment(contractDetails?.endDate).format(
                        DATE_FORMATS[i18next.language] || DEFAULT_DATE_FORMAT
                      )
                    })
                  : t('contracts:notifications.errors.endDate'),
                onChange: (newEndDate: any, formState) => {
                  const contractATRDetails = formState as ContractATRFormModel
                  validateNewStartDateATR(contractATRDetails.newStartDate, newEndDate)
                  validateNewEndDateATR(contractATRDetails.newStartDate, newEndDate)
                }
              }
            ]
          },
          {
            title: 'Periodos',
            inputs: [
              {
                name: 'tollType',
                label: t('contracts:forms.details.inputs.toll'),
                type: DataType.SELECT,
                isLoading: isFetchingTolls,
                required: true,
                selectOptions: pressureGroup
                  ? listTollItemMapper(
                      tollList!.filter(
                        x => x.pressureGroupList.findIndex(x => x === pressureGroup) > -1
                      )
                    )
                  : listTollItemMapper(tollList!),
                onChange: (value, formState: any) => {
                  onChangeToll(value)
                }
              },
              {
                name: 'period1',
                label: t('contracts:forms.add.inputs.period1'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[1],
                display: periodsVersionFormConfig[1]
              },
              {
                name: 'period2',
                label: t('contracts:forms.add.inputs.period2'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[2],
                display: periodsVersionFormConfig[2]
              },
              {
                name: 'period3',
                label: t('contracts:forms.add.inputs.period3'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[3],
                display: periodsVersionFormConfig[3]
              },
              {
                name: 'period4',
                label: t('contracts:forms.add.inputs.period4'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[4],
                display: periodsVersionFormConfig[4]
              },
              {
                name: 'period5',
                label: t('contracts:forms.add.inputs.period5'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[5],
                display: periodsVersionFormConfig[5]
              },
              {
                name: 'period6',
                label: t('contracts:forms.add.inputs.period6'),
                suffix: t('contracts:forms.add.units.kW'),
                type: DataType.NUMBER,
                customDecimalScale: 3,
                required: periodsVersionFormConfig[6],
                display: periodsVersionFormConfig[6]
              }
            ]
          }
        ]
      }
    }, [
      validations.endDate,
      validations.endDateContract,
      validations.newStartDate,
      validations.newStartDateContract,
      validations.newStartDatePast,
      validations.newEndDate,
      validations.newEndDateContract,
      tollList,
      servicesList,
      pressureGroup,
      intraDay,
      qaRequired,
      qdRequired,
      periodsVersionFormConfig,
      isFetchingTolls,
      formMode
    ])

  const tollAndServiceDefinition = React.useCallback(
    (newPressureGroup: number) => {
      return {
        id: 'EDIT',
        sections: [
          {
            inputs: [
              {
                name: 'label',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
                type: DataType.LABEL,
                labelTitle:
                  'Modificar el grupo de presión/tensión asociado a un contrato implica reasignar los valores de servicio y peaje. Este cambio puede suponer un cambio en el cálculo de costes regulados de futuras facturas o necesidad de refacturar antiguas si el valor anterior fuera erróneo'
              },
              {
                name: 'toll',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.toll'),
                type: DataType.SELECT,
                selectOptions: defineTollSelectOptionList(newPressureGroup),
                required: true
              },
              {
                name: 'contractType',
                label: t('contracts:components.capacitiesTable.actions.edit.inputs.service'),
                type: DataType.SELECT,
                selectOptions: servicesList,
                required: true,
                defaultValue: undefined,
                display: commodity === EnumCommodity.GasNatural
              }
            ]
          }
        ]
      }
    },
    [
      validationsDialog.startDate,
      validationsDialog.endDate,
      validationsDialog.startDateContract,
      validationsDialog.endDateContract,
      tollList,
      servicesList
    ]
  )

  const onAddCapacityClickHandler = () => {
    setIntraDay(false)
    const { initialToll, initialQaEstimada, initialCode } = getInitialValues()
    setRequiredByToll(initialToll)
    openForm({
      definition: capacityAddDefinition,
      title: t('contracts:components.capacitiesTable.actions.add.title'),
      okBtnLabel: t('contracts:components.capacitiesTable.actions.edit.okBtnLabel'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: formData => {
        if (formData) {
          if (missingFieldsFormWithRequiredText(capacityAddDefinition.sections!, formData)) {
            notifyError(t('contracts:notifications.create.errorInvalidForm'))
            return
          }
          getInformationSave(() => onCloseAddCapacityForm(formData as CapacityFormModel))
        } else {
          onCancelDialog()
        }
      },
      inputData: {
        toll: initialToll,
        qaEstimada: initialQaEstimada,
        code: initialCode,
        startDate: contractDetails?.startDate,
        endDate: contractDetails?.endDate
      }
    })
  }

  const onEditCapacityClickHandler = (capacity: CapacityFormModel) => {
    const isIntraday = capacity.type === EnumTipoProductoCapacidad.Intradiario
    isIntraday ? setIntraDay(true) : setIntraDay(false)
    ;(openForm({
      definition: capacityEditDefinition,
      title: t('contracts:components.capacitiesTable.actions.edit.title'),
      okBtnLabel: t('contracts:components.capacitiesTable.actions.edit.okBtnLabel'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: formData => {
        formData
          ? getInformationSave(() => onCloseEditCapacityForm(formData as CapacityFormModel))
          : onCancelDialog()
      },
      inputData: capacity
    }),
      setRequiredByToll(capacity.toll))
  }

  const onAddAtrVersionHandler = async (): Promise<boolean> => {
    // Prevents user from adding two new Versions
    if (contractATR?.generateNewVersion) {
      await getInformation(InformationDialogs.CONTRACT_ATR_NOT_ACTIVE).then(response =>
        closeInformation()
      )
      return true
    }

    // Prevents user from adding a future version if one already exists
    if (hasFutureVersion() || !latestVersionHasPastStartDate()) {
      await getInformation(InformationDialogs.CONTRACT_ATR_FUTURE_VERSION_EXISTS).then(response =>
        closeInformation()
      )
      return true
    }

    // preload initial values for better UX
    const latestVersion =
      contractDetails?.contractATR &&
      mapATRVersionToTableModel(
        getLatestVersion(contractDetails.contractATR),
        contractDetails.contractATR?.state
      )
    const newStartDate = moment(latestVersion?.endDate).isSameOrAfter(
      contractDetails?.endDate,
      'days'
    )
      ? moment(latestVersion?.endDate).toDate()
      : moment(latestVersion?.endDate).add(1, 'days').toDate()
    const newEndDate = moment(latestVersion?.endDate).isBefore(contractDetails?.endDate, 'days')
      ? moment(contractDetails?.endDate).toDate()
      : moment(latestVersion?.endDate).toDate()
    onChangeToll(latestVersion?.tollType)

    // open modal form
    setFormMode(FormDialogMode.ADD)
    openForm({
      definition: atrVersionFormDefinition,
      title: t('contracts:forms.details.titles.addContractATRVersion'),
      okBtnLabel: t('contracts:forms.details.actions.okBtnLabel'),
      mode: FormDialogMode.ADD,
      isWaiting: false,
      onClose: onCloseAddAtrVersionForm,
      inputData: {
        code: contractATR?.code,
        type: contractATR?.type,
        state: contractATR?.state,
        latestVersionIdDetail: latestVersion?.idDetail,
        latestVersionNumber: [latestVersion?.version],
        tollType: latestVersion?.tollType,
        startDate: latestVersion?.startDate,
        endDate: latestVersion?.endDate,
        newStartDate: newStartDate,
        newEndDate: newEndDate,
        period1id: latestVersion?.period1id,
        period1: latestVersion?.period1,
        period2id: latestVersion?.period2id,
        period2: latestVersion?.period2,
        period3id: latestVersion?.period3id,
        period3: latestVersion?.period3,
        period4id: latestVersion?.period4id,
        period4: latestVersion?.period4,
        period5id: latestVersion?.period5id,
        period5: latestVersion?.period5,
        period6id: latestVersion?.period6id,
        period6: latestVersion?.period6,
        canEdit: true
      }
    })

    return true
  }

  const onEditAtrVersionHandler = (rowData: ATRVersionTableModel) => {
    setFormMode(FormDialogMode.EDIT)
    onChangeToll(rowData.tollType) // si se cambia de peaje se actualizan los campos de potencias a mostrar
    setDbContractDetails(prevState => {
      return {
        ...prevState,
        contractATR: {
          ...prevState.contractATR,
          ...mapATRVersionTableToContractDetails(rowData),
          version: rowData.version[0] ?? 0
        }
      }
    })
    openForm({
      definition: atrVersionFormDefinition,
      title: t('contracts:forms.details.titles.editContractATRVersion', {
        version: rowData.version[0]
      }),
      okBtnLabel: t('contracts:forms.details.actions.okBtnLabel'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: (formData: ContractATRFormModel) => onCloseEditAtrVersionForm(formData, rowData),
      inputData: {
        ...rowData,
        code: contractATR?.code,
        type: contractATR?.type,
        state: contractATR?.state,
        cupsId: cups.id,
        companyId: contractATR?.companyID
      }
    })
  }

  const onDeleteAtrVersionHandler = (rowData: ATRVersionTableModel) => {
    getConfirmation(ConfirmationDialogs.DELETE).then(() => {
      setCurrentATR(prevState => ({
        ...prevState,
        state: EnumEstadoProductoCapacidad.Borrador
      }))
      setContractATR(prevState => ({
        ...prevState,
        state: EnumEstadoProductoCapacidad.Borrador
      }))
      setPendingChanges(true)
      setCanChangeATRState(false)
      markVersionAsDeleted(rowData)
      closeConfirmation()
    })
  }

  const onCreateProcedureHandler = () => {
    history.push(NonAuthRoutes.ProceduresAdd, {
      contractId: contractID,
      formMode: ProcedureFormMode.CAMBIO_CONTRATO_ATR
    })
  }

  const markVersionAsDeleted = (rowData: ATRVersionTableModel) => {
    const updatedVersions = atrVersions?.map(version => {
      if (version.idDetail === rowData.idDetail) {
        return {
          ...version,
          actions: associateActionIcon(version, ActionIcons.DELETE_ITEM)
        }
      }
      return version
    })

    updatedVersions && setAtrVersions(updatedVersions)

    setContractATRDetails(prevDetails => {
      const existingIndex = prevDetails.findIndex(d => d.id === rowData.idDetail)

      if (existingIndex >= 0) {
        const updated = [...prevDetails]
        updated[existingIndex] = {
          ...updated[existingIndex],
          delete: true
        }
        return updated
      }

      return [
        ...prevDetails,
        {
          id: rowData.idDetail,
          idContractATR: contractATR?.id,
          delete: true
        } as PatchContractATRDetail
      ]
    })
  }

  const onCancelDialog = () => {
    setValidationsDialog(initialCapacityValidations)
    closeForm()
  }

  const onCloseAddCapacityForm = (capacity: CapacityFormModel) => {
    if (capacity) {
      setPendingChanges(true)
      capacity.cupsId = cups.id
      capacity.logisticElementId = cups.logisticElementId
      capacity.signDate = contractDetails?.signatureDate
      const updatedList = addNewItemTempList(
        newCapacityFormModelConsolidate(capacity),
        tempCapacities ?? [],
        true
      )
      setCapacities(updatedList)
    }

    closeForm()
  }

  const onCloseEditCapacityForm = (capacity: CapacityFormModel) => {
    if (capacity) {
      setPendingChanges(true)
      const updatedList = updateTempList(capacity, tempCapacities ?? [], true)
      setCapacities(updatedList)
    }

    setValidationsDialog(initialCapacityValidations)
    closeForm()
  }

  const onCloseAddAtrVersionForm = (formData: ContractATRAddVersionFormModel) => {
    /*
    okButton form reactUI Globaleris library do not prevent from saving until 
    any form Value is updated. Also, as form inputs display/required changes if tollType is changed, 
    a useRef is needed to acceses de definition.section of the form that has been updated.
    Otherwise, in this function context, openForm() memoize onCloseAddAtrVersionForm function
    and its values, resulting in the old version of atrVersionAddDefinition. That's the reason
    beacause console.log(atrVersionAddDefinition) is different wheter it is outside of this function 
    or inside of it.  
    */

    if (
      formData &&
      missingFieldsFormWithRequiredText(atrVersionFormDefinitionRef.current.sections!, formData)
    ) {
      notifyError(t('contracts:notifications.create.errorInvalidForm'))
      return
    }

    if (formData) {
      setPendingChanges(true)
      setCanChangeATRState(false)
      addVersionOnTableComponent(formData)
      addPowersToPowerState(formData)
      addVersionToContractATRDetails(formData)
      setContractATR(prevState => ({
        ...prevState,
        ...formData,
        startDate: formData.startDate,
        endDate: formData.endDate,
        newStartDate: formData.newStartDate,
        newEndDate: formData.newEndDate,
        generateNewVersion: true,
        state: EnumEstadoProductoCapacidad.Borrador
      }))
      setCurrentATR(prevState => ({
        ...prevState,
        state: EnumEstadoProductoCapacidad.Borrador
      }))
    }
    resetAddVersionATRValidations()
    setFormMode(null)
    closeForm()
  }

  const onCloseEditAtrVersionForm = (
    formData: ContractATRFormModel,
    originalRowData: ATRVersionTableModel
  ) => {
    if (
      formData &&
      missingFieldsFormWithRequiredText(atrVersionFormDefinitionRef.current.sections!, formData)
    ) {
      notifyError(t('contracts:notifications.create.errorInvalidForm'))
      return
    }

    if (formData) {
      setPendingChanges(true)
      setCanChangeATRState(false)
      updateVersionOnTableComponent(formData, originalRowData)
      updatePowerState(formData, originalRowData)
      // updateContractDetails(formData, originalRowData)
      setContractATR(prevState => {
        return {
          ...prevState,
          ...formData,
          startDate: formData.startDate,
          endDate: formData.endDate,
          state: EnumEstadoProductoCapacidad.Borrador
        }
      })
      setCurrentATR(prevState => ({
        ...prevState,
        code: formData.code,
        type: formData.type,
        state: EnumEstadoProductoCapacidad.Borrador
      }))
    }
    resetAddVersionATRValidations()
    setStartDateHelpText(undefined)
    setFormMode(null)
    closeForm()
  }

  const addVersionOnTableComponent = (formData: ContractATRAddVersionFormModel) => {
    // map version to Table component
    const newVersion = mapAddVersionToTableModel(formData)
    // map atrVersions and change latest Version if needed
    const atrVersionsUpdated = atrVersions?.map(v => {
      if (
        v.idDetail === formData.latestVersionIdDetail &&
        (!v.endDate || moment(v.endDate).isAfter(moment(formData.newStartDate), 'days'))
      ) {
        // updateContractDetails({...v, version:v[0],endDate: formData.endDate} as ContractATRFormModel, v)
        return {
          ...v,
          endDate: formData.endDate,
          canEdit: versionIsCurrentOrFuture(formData.endDate),
          actions: associateActionIcon(v, ActionIcons.NEW_ITEM, 'No Guardado')
        }
      } else {
        return v
      }
    })
    // set new Table state and form contractATR
    atrVersionsUpdated && setAtrVersions([newVersion, ...atrVersionsUpdated])
  }

  const addPowersToPowerState = (formData: ContractATRFormModel) => {
    setPowers(prevState => [...prevState, ...contractATRFormToPostPower(formData)])
  }

  const addVersionToContractATRDetails = (formData: ContractATRAddVersionFormModel) => {
    const latestVersion = atrVersions?.find(
      v =>
        v.idDetail === formData.latestVersionIdDetail &&
        (!v.endDate || moment(v.endDate).isAfter(moment(formData.newStartDate), 'days'))
    )
    latestVersion &&
      updateContractDetails(
        mapVersiontoContractATRForm(latestVersion, formData) as ContractATRFormModel,
        latestVersion
      )
    setContractATRDetails(prevState => [
      ...prevState,
      contractATRFormToPostContractATRDetail({ ...formData, id: contractATR?.id })
    ])
  }

  const mapVersiontoContractATRForm = (
    version: ATRVersionTableModel | undefined,
    formData: ContractATRAddVersionFormModel
  ): ContractATRFormModel | undefined => {
    return (
      version && {
        ...version,
        tollType: version.tollType!,
        version: version[0],
        endDate: formData.endDate
      }
    )
  }

  const mapVersionToFormData = (
    version: ATRVersionTableModel | undefined
  ): ContractATRFormModel | undefined => {
    return (
      version && {
        ...version,
        tollType: version.tollType!,
        version: version[0]
      }
    )
  }

  const updateVersionOnTableComponent = (
    formData: ContractATRFormModel,
    originalRowData: ATRVersionTableModel
  ) => {
    const updatedVersionTableData = mapUpdateVersionToTableModel(formData)
    // map atrVersions and change updated one
    const newVersionState = atrVersions?.map(version => {
      if (version.idDetail === updatedVersionTableData.idDetail) {
        updateContractDetails(formData, originalRowData)
        return updatedVersionTableData
      } else if (dateOverlapsPreviousVersion(version, updatedVersionTableData)) {
        const previousVersionUpdated: ATRVersionTableModel = {
          ...version,
          endDate: moment(updatedVersionTableData.startDate).add(-1, 'days').toDate(),
          canEdit: versionIsCurrentOrFuture(formData.endDate),
          actions: associateActionIcon(version, ActionIcons.NEW_ITEM, 'No Guardado')
        }
        updateContractDetails(mapVersionToFormData(previousVersionUpdated)!, version)
        return previousVersionUpdated
      } else {
        return version
      }
    })
    newVersionState && setAtrVersions([...newVersionState])
  }

  const updatePowerState = (
    formData: ContractATRFormModel,
    originalRowData: ATRVersionTableModel
  ) => {
    setPowers(prevState => {
      // Editing a pending new version (no idDetail yet): replace its ADD entries wholesale
      // to avoid orphaned entries when the toll changes and some periods are removed
      if (!originalRowData.idDetail) {
        const base = prevState.filter(
          power => power.idContractATRDetail !== undefined || power.idPower !== undefined
        )
        return [...base, ...contractATRFormToPostPower(formData)]
      }

      // map Powers modified in this form
      const newPowers = contractATRFormToPatchPowerModelMapper(formData, originalRowData)

      // check if powers were already modified to avoid duplication (i.e. id repetition)
      const updatedPowers = [...prevState]
      newPowers.forEach(newPower => {
        // A "delete" with no idPower means the period was only a pending, unsaved creation
        // (never persisted) that got removed again within the same session: there's nothing
        // to tell the API to delete, so the pending entry must just be dropped locally
        const isUndoOfPendingCreate = newPower.delete && newPower.idPower == null

        const existingIndex = updatedPowers.findIndex(
          power =>
            (power.idPower && power.idPower === newPower.idPower) || // existing power of existing version has been already edited case
            (power.idContractATRDetail &&
              power.period === newPower.period &&
              power.idContractATRDetail === newPower.idContractATRDetail) || // new power of existing version  has been already edited case
            (newPower.idContractATRDetail === undefined &&
              power.idContractATRDetail === undefined &&
              power.period === newPower.period) // new power of new version has been already edited case
        )
        if (existingIndex !== -1) {
          if (isUndoOfPendingCreate) {
            // Drop the pending create entirely, don't send a meaningless delete-with-no-id
            updatedPowers.splice(existingIndex, 1)
          } else {
            // Replace existing power entirely: newPower fully describes the current intent
            // (create/update/delete) for this period, so merging would leak stale flags like
            // delete:true from a previous edit of the same version within this session
            updatedPowers[existingIndex] = newPower
          }
        } else if (!isUndoOfPendingCreate) {
          // Add new power
          updatedPowers.push(newPower)
        }
      })
      return updatedPowers
    })
  }

  const updateContractDetails = (
    formData: ContractATRFormModel,
    originalRowData: ATRVersionTableModel
  ) => {
    const updatedDetail = getDiffContractDetailATR(formData, {
      ...originalRowData,
      id: contractATR?.id
    } as any)
    if (updatedDetail) {
      setContractATRDetails(prevState => {
        const existingIndex = getValueIndexIfExists(prevState, updatedDetail, 'id')
        let updatedContractDetails = [...prevState]
        if (existingIndex !== -1) {
          updatedContractDetails[existingIndex] = updatedDetail
        } else {
          updatedContractDetails.push(updatedDetail)
        }
        return updatedContractDetails
      })
    }
  }

  const dateOverlapsPreviousVersion = (
    version: ATRVersionTableModel,
    updatedVersion: ATRVersionTableModel
  ): boolean => {
    return (
      updatedVersion.version[0] - version.version[0] === 1 && // checks if version is previous one
      (!version.endDate ||
        moment(version.endDate).isAfter(moment(updatedVersion.startDate), 'days')) && // checks if dates are overlap
      moment(version.startDate).isBefore(moment(updatedVersion.startDate), 'days') // checks if change would be valid - ie startDate < endDate of the same version
    )
  }

  const getValueIndexIfExists = <T extends any>(
    originalArray: T[],
    updatedValue: T,
    property: string
  ): number => {
    return originalArray.findIndex(value => value[property] === updatedValue[property])
  }

  const getInformationSave = async (
    callback: () => void,
    type: InformationDialogs = InformationDialogs.PENDING_SAVE
  ) => {
    await getInformation(type).then(res => {
      setPendingChanges(true)
      closeInformation()
      return callback()
    })
  }

  const updatePeriodsValues = (showPeriod: PeriodsFormConfig) => {
    if (commodity === EnumCommodity.Electricidad) {
      let periods = {}
      for (let i = 1; i <= 6; i++) {
        if (!showPeriod[i]) {
          // If the period is not valid for this Toll, set its value to undefined
          periods[`period${i}`] = undefined
        }
      }
      updateFormData(prevState => ({ ...prevState, ...periods }))
    }
  }

  const updateStartDateHelpText = (formData: ContractATRFormModel) => {
    setStartDateHelpText(
      `La fecha de fin de la versión ${formData.version - 1} será modificada al ${toLocaleDate(moment(formData.startDate).add(-1, 'day').toDate())}`
    )
  }
  const onChangePressure = async (commodity: EnumCommodity) => {
    if (commodity === EnumCommodity.Electricidad) {
      const config = getPeriodsConfig(0)
      setPeriodsFormConfig(config as PeriodsFormConfig)
      updatePeriodsValues(config as PeriodsFormConfig)
    }
  }

  const getDistributors = async (commodityType: EnumCommodity) => {
    setIsFetchingDistributor(true)
    await fetchSubjectsByTypeAndCommodity(EnumTipoSujeto.Distribuidor, commodityType).then(
      response => {
        if (response.data !== undefined) {
          setDistributorList(response.data)
        }
      }
    )
    setIsFetchingDistributor(false)
    return Promise.resolve()
  }

  const getTolls = async (commodityType: EnumCommodity) => {
    setIsFetchingTolls(true)
    await fetchTolls(commodityType).then(response => {
      if (response.data !== undefined) {
        setTollList(response.data)
      }
    })
    setIsFetchingTolls(false)
    return Promise.resolve()
  }

  const getServices = async (clientType: EnumTipoSujeto) => {
    await fetchServices(clientType).then(response => {
      if (response.data !== undefined) {
        setServicesList(response.data)
      }
    })
    return Promise.resolve()
  }

  const getActivityTypes = async () => {
    setIsFetchingCnae(true)
    await fetchActivityTypes().then(response => {
      const CNAEList = response.data
      if (CNAEList !== undefined) {
        setCnaeList(CNAEList)
        // cupsCNAEMapper ya maneja correctamente todos los casos con el ?? operator
        setCups(prevState => cupsCNAEMapper(prevState, CNAEList))
      }
    })
    setIsFetchingCnae(false)
    return Promise.resolve() // Asegurar que retorna una promesa
  }

  const getPressureGroup = async (commodityType: EnumCommodity) => {
    setIsFetchingPressure(true)
    await fetchPressureGroup(commodityType).then(response => {
      if (response.data !== undefined) {
        setPressureGroupList(response.data)
      }
    })
    setIsFetchingPressure(false)
    return Promise.resolve()
  }

  const configureATRForm = (contractATR: ContractATRFormModel) => {
    if (contractATR.periods) {
      contractATR.periods.forEach(period => {
        setPeriodsFormConfig(prevState => ({ ...prevState, [period.period]: period.value }))
      })
    }
    onChangeToll(contractATR.tollType)
  }

  const getPeriodsConfig = (periodsQtyToShow: number) => {
    let config = {}
    for (let i = 1; i <= 6; i++) {
      config[i] = i <= periodsQtyToShow ? true : false
    }
    return config
  }

  const getPeriodsConfigFromTableRow = (rowData: ATRVersionTableModel): PeriodsFormConfig => {
    let config = {}
    for (let i = 1; i <= 6; i++) {
      config[i] = rowData[`period${i}`] !== undefined ? true : false
    }
    return config as PeriodsFormConfig
  }

  const onChangeToll = async (toll: any) => {
    if (toll) {
      await fetchPowerPeriodsByToll(toll).then(response => {
        if (response.data !== undefined) {
          const periodsQty: number = response.data
          const config = getPeriodsConfig(periodsQty)
          setPeriodsVersionFormConfig(config as PeriodsFormConfig)
          updatePeriodsValues(config as PeriodsFormConfig)
        }
      })
    }
  }

  const setRequiredByToll = (toll: any) => {
    if (
      toll == EnumTipoPeaje.Peaje_R1 ||
      toll == EnumTipoPeaje.Peaje_R2 ||
      toll == EnumTipoPeaje.Peaje_R3 ||
      toll == EnumTipoPeaje.Peaje_R4 ||
      toll == EnumTipoPeaje.Peaje_B5 ||
      toll == EnumTipoPeaje.Peaje_B6 ||
      toll == EnumTipoPeaje.Peaje_B7
    ) {
      setQaRequired(true)
    } else {
      setQaRequired(false)
    }
    if (
      toll == EnumTipoPeaje.Peaje_A5 ||
      toll == EnumTipoPeaje.Peaje_A6 ||
      toll == EnumTipoPeaje.Peaje_A7 ||
      toll == EnumTipoPeaje.Peaje_R5 ||
      toll == EnumTipoPeaje.Peaje_R6 ||
      toll == EnumTipoPeaje.Peaje_R7 ||
      toll == EnumTipoPeaje.Peaje_R8 ||
      toll == EnumTipoPeaje.Peaje_R9 ||
      toll == EnumTipoPeaje.Peaje_R10 ||
      toll == EnumTipoPeaje.Peaje_R11
    ) {
      setQdRequired(true)
    } else {
      setQdRequired(false)
    }
  }

  const checkCups = async (cupsCode: string) => {
    const codeStr = (cupsCode ?? '').trim()
    if (!codeStr) {
      setCupsCodeErrorKey('cupsCodeRequired')
      handleFormDirty('cupsCode', false)
      return
    }
    if (codeStr.length < 20 || codeStr.length > 22) {
      setCupsCodeErrorKey('cupsCodeLength')
      handleFormDirty('cupsCode', false)
      return
    }
    if (cups) {
      let exists: boolean | null = null
      const commodity = contractDetails?.contractATR
        ? EnumCommodity.Electricidad
        : EnumCommodity.GasNatural
      exists = await fetchCUPSByCode(codeStr, commodity).then(async response => {
        if (response.success) {
          return response.data?.id && response.data.id !== dbContractDetails?.cups?.id
            ? true
            : false
        }
        return null
      })
      if (exists != null) {
        setCupsCodeErrorKey('cupsCode')
        handleFormDirty('cupsCode', !exists)
      }
    }
  }

  const handlePressureGroupChange = (newPressureGroup: number) => {
    onEditPressureGroupHandler(newPressureGroup)
  }

  const handleCancelEditPressure = () => {
    setCups(prevState => ({
      ...prevState,
      pressureGroup: pressureGroup
    }))
    closeForm()
  }

  const onEditPressureGroupHandler = (newPressureGroup: number) => {
    openForm({
      definition: tollAndServiceDefinition(newPressureGroup),
      title:
        commodity === EnumCommodity.Electricidad
          ? t('contracts:components.capacitiesTable.actions.changeGroupPressure.titlePower')
          : t('contracts:components.capacitiesTable.actions.changeGroupPressure.titleGas'),
      okBtnLabel: t('contracts:components.capacitiesTable.actions.edit.okBtnLabel'),
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: formData => {
        formData
          ? onCloseEditPressureGroupForm(formData, newPressureGroup)
          : handleCancelEditPressure()
      }
    })
  }

  const onCloseEditPressureGroupForm = (
    { toll, contractType }: { toll: number; contractType: number },
    newPressureGroup: number
  ) => {
    setPressureGroup(+newPressureGroup)
    onChangePressure(commodity)
    onChangeToll(toll)
    setPendingChanges(true)

    if (commodity === EnumCommodity.Electricidad) {
      setContractATR(prevState => ({
        ...prevState,
        tollType: toll,
        period1: undefined,
        period2: undefined,
        period3: undefined,
        period4: undefined,
        period5: undefined,
        period6: undefined
      }))
    } else {
      const updatedList = capacities.map(cap => ({
        ...cap,
        toll,
        contractType,
        tempId: generateUniqueKeyWithNoPrefix(),
        canEdit: true
      }))
      setCapacities(updatedList)
    }

    closeForm()
  }

  const updateAddress = async (option: SearchSelectOption | null) => {
    if (!option) {
      setCups(prevState => ({
        ...prevState,
        municipalityId: undefined,
        municipality: '',
        provinceId: undefined,
        province: '',
        countryId: undefined,
        country: '',
        postalCode: ''
      }))
      return
    }

    !isInitialLoad && setPendingChanges(true)
    const postalAddress = await getPostalAddressByID(+option.value).catch(e => {})

    if (postalAddress) {
      setCups(prevState => ({
        ...prevState,
        municipalityId: postalAddress.municipality.id,
        municipality: postalAddress.municipality.description,
        provinceId: postalAddress.province.id,
        province: postalAddress.province.description,
        countryId: postalAddress.country.id,
        country: postalAddress.country.description,
        postalCode: option.textValue
      }))
    }
  }

  // Memoizar las opciones de CNAE para evitar re-renders innecesarios
  const cnaeSelectOptions = useMemo(() => listCnaeItemMapper(cnaeList), [cnaeList])
  const distributorSelectOptions = useMemo(
    () => listDistributorItemMapper(distributorList),
    [distributorList]
  )
  const pressureGroupSelectOptions = useMemo(() => pressureGroupList, [pressureGroupList])
  const tollSelectOptions = useMemo(
    () =>
      pressureGroup
        ? listTollItemMapper(
            tollList!.filter(x => x.pressureGroupList.findIndex(x => x === pressureGroup) > -1)
          )
        : listTollItemMapper(tollList!),
    [tollList, pressureGroup]
  )

  const cupsSection: Section[] = useMemo(
    () => [
      {
        inputs: [
          {
            name: 'code',
            label: t('contracts:forms.details.inputs.cupsCode'),
            type: DataType.TEXT,
            required: true,
            errorState: !validations.cupsCode,
            errorText: t(`contracts:notifications.errors.${cupsCodeErrorKey}`),
            onBlur: newCode => {
              !isInitialLoad && setPendingChanges(true)
              const codeStr = `${newCode ?? ''}`.trim()
              setCups(prevState => ({ ...prevState, code: codeStr }))
              checkCups(codeStr)
            }
          },
          {
            name: 'distributorId',
            label: t('contracts:forms.details.inputs.distributor'),
            type: DataType.SELECT,
            selectOptions: distributorSelectOptions,
            isLoading: isFetchingDistributor,
            readOnly: true,
            required: true
          },
          {
            name: 'telemetered',
            label: t('contracts:forms.details.inputs.telemetered'),
            type: DataType.SWITCH,
            onChange(value, formState) {
              !isInitialLoad && setPendingChanges(true)
            }
          },
          {
            name: 'pressureGroup',
            label: t('contracts:forms.details.inputs.pressureGroup'),
            type: DataType.SELECT,
            selectOptions: pressureGroupSelectOptions,
            isLoading: isFetchingPressure,
            required: true,
            onChange: (value, formState: any) => {
              handlePressureGroupChange(+value)
            }
          },
          {
            name: 'cnaeId',
            label: t('contracts:forms.details.inputs.cnae'),
            type: DataType.SELECT,
            selectOptions: cnaeSelectOptions,
            isLoading: isFetchingCnae,
            onChange: newCnae => {
              !isInitialLoad && setPendingChanges(true)
              // get cnae code from cnaeList with number newCnae
              const cnaeCode = cnaeList.find(c => c.id === newCnae)?.code
              setCups(prevState => ({
                ...prevState,
                cnaeId: +newCnae,
                cnaeCode: cnaeCode ?? ''
              }))
            }
          },
          {
            name: 'postalAddress',
            label: t('contracts:forms.edit.inputs.street'),
            type: DataType.TEXT,
            required: true,
            onBlur: value => {
              !isInitialLoad && setPendingChanges(true)
              setCups(prevState => ({ ...prevState, postalAddress: `${value}` }))
            }
          },
          {
            name: 'postalCodeSelect',
            label: t('contracts:forms.edit.inputs.postalCode'),
            type: DataType.SEARCHFIELD,
            apiCall: fetchPostalCodes,
            defaultValue: { value: initialPostalCode, label: initialPostalCode },
            maxLength: 5,
            required: true,
            onClear: () => {
              updateAddress(null)
            },
            onChange: newCode => {
              const option = newCode as any
              updateAddress(option)
            }
          },
          {
            name: 'municipality',
            label: t('contracts:forms.edit.inputs.municipality'),
            type: DataType.TEXT,
            required: true,
            readOnly: true
            // onChange: (value, formState: Partial<ContractForm>) => {
            //   setPendingChanges(true)
            //   if (municipalities && provinces && countries) {
            //     let filter = municipalities.find(x => x.id === value)
            //     let province = provinces.find(x => x.id === filter?.provinceID)
            //     let country = countries.find(x => x.value === province?.countryID)
            //     validatePostalCode(formState?.postalCode, province?.id)
            //     setCups(prevState => ({
            //       ...prevState,
            //       provinceId:
            //         provinces.find(m => m.description === province?.description)?.id ?? undefined,
            //       countryId:
            //         provinces.find(m => m.description === province?.description)?.countryID ??
            //         undefined
            //     }))
            //   }
            // }
          },
          {
            name: 'province',
            label: t('contracts:forms.edit.inputs.province'),
            type: DataType.TEXT,
            required: true,
            readOnly: true
            // onChange: (newProvince, formState: Partial<ContractForm>) => {
            //   setPendingChanges(true)
            //   validatePostalCode(formState?.postalCode, +newProvince)
            //   if (formState?.municipalityId) {
            //     // Si hay seleccionada una municipalidad, se chequea que pertenezca a la provincia seleccionada
            //     const municipality = municipalities?.find(m => m.id === formState.municipalityId)
            //     municipality?.provinceID &&
            //       municipality?.provinceID !== newProvince &&
            //       setCups(prevState => ({
            //         ...prevState,
            //         municipalityId: undefined
            //       }))
            //   }
            //   const country = provinces?.find(p => p.id === newProvince)?.countryID
            //   country &&
            //     country !== cups?.countryId &&
            //     setCups(prevState => ({
            //       ...prevState,
            //       countryId: country
            //     }))
            // }
          },
          {
            name: 'country',
            label: t('contracts:forms.edit.inputs.country'),
            type: DataType.TEXT,
            required: true,
            readOnly: true
            // onChange: newCountry => {
            //   setPendingChanges(true)
            //   setCups(prevState => ({
            //     ...prevState,
            //     municipalityId: undefined,
            //     provinceId: undefined,
            //     postalCode: undefined
            //   }))
            // }
          },
          {
            name: 'height',
            label: t('contracts:forms.details.inputs.height'),
            type: DataType.NUMBER,
            clearable: true,
            customDecimalScale: 0,
            onChange: (value, formState) => {
              const newHeight = value ? +value : value === 0 ? 0 : undefined
              // Solo marcar como cambio pendiente si el valor realmente cambió
              if (!isInitialLoad && newHeight !== cups.height) {
                setPendingChanges(true)
              }
              setCups(prevState => ({
                ...prevState,
                height: newHeight
              }))
            }
          }
        ]
      }
    ],
    [
      t,
      validations.cupsCode,
      cupsCodeErrorKey,
      distributorSelectOptions,
      isFetchingDistributor,
      pressureGroupSelectOptions,
      isFetchingPressure,
      cnaeSelectOptions,
      isFetchingCnae,
      initialPostalCode,
      isInitialLoad
    ]
  )

  const contractATRSection: Section[] = useMemo(
    () => [
      {
        inputs: [
          {
            name: 'code',
            label: t('contracts:forms.details.inputs.ATRCode'),
            type: DataType.TEXT,
            required: true,
            errorText: t('contracts:notifications.errors.contractATRcode'),
            readOnly: true
          },
          {
            name: 'type',
            label: t('contracts:forms.details.inputs.ATRType'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(
              EnumTipoContratoATR,
              'enums:EnumTipoContratoATR'
            ),
            readOnly: true
          },
          {
            name: 'state',
            label: t('contracts:forms.details.inputs.status'),
            type: DataType.SELECT,
            selectOptions: enumToSelectOptionArray(
              EnumEstadoProductoCapacidad,
              'enums:EnumEstadoProductoCapacidad'
            ).filter(option =>
              [
                EnumEstadoProductoCapacidad.Borrador,
                EnumEstadoProductoCapacidad.Solicitado,
                EnumEstadoProductoCapacidad.Rechazada,
                EnumEstadoProductoCapacidad.Activo,
                EnumEstadoProductoCapacidad.Baja,
                EnumEstadoProductoCapacidad.PendienteModificacion,
                EnumEstadoProductoCapacidad.Anulada
              ].includes(+option.value)
            ),
            onChange: (newState: any) => {
              if (pendingChanges && newState.state === EnumEstadoProductoCapacidad.Borrador) {
                setCanChangeATRState(false)
              }
              !isInitialLoad && setPendingChanges(true)
              setCurrentATR(prevState => ({
                ...prevState,
                state: +newState
              }))
              updateVersionsCanEdit(+newState)
            }
          },
          {
            name: 'startDate',
            label: t('contracts:forms.details.inputs.currentStartDate'),
            type: DataType.DATE,
            required: true,
            readOnly: true
          },
          {
            name: 'endDate',
            label: t('contracts:forms.details.inputs.currentEndDate'),
            type: DataType.DATE,
            readOnly: true
          }
        ]
      },
      {
        title: 'Periodos',
        inputs: [
          {
            name: 'tollType',
            label: t('contracts:forms.details.inputs.toll'),
            type: DataType.SELECT,
            isLoading: isFetchingTolls,
            required: true,
            selectOptions: tollSelectOptions,
            readOnly: true
          },
          {
            name: 'period1',
            label: t('contracts:forms.add.inputs.period1'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[1],
            readOnly: true
          },
          {
            name: 'period2',
            label: t('contracts:forms.add.inputs.period2'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[2],
            readOnly: true
          },
          {
            name: 'period3',
            label: t('contracts:forms.add.inputs.period3'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[3],
            readOnly: true
          },
          {
            name: 'period4',
            label: t('contracts:forms.add.inputs.period4'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[4],
            readOnly: true
          },
          {
            name: 'period5',
            label: t('contracts:forms.add.inputs.period5'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[5],
            readOnly: true
          },
          {
            name: 'period6',
            label: t('contracts:forms.add.inputs.period6'),
            suffix: t('contracts:forms.add.units.kW'),
            type: DataType.NUMBER,
            customDecimalScale: 3,
            required: true,
            display: periodsFormConfig[6],
            readOnly: true
          }
        ]
      }
    ],
    [
      t,
      pendingChanges,
      validations,
      contractDetails,
      tollSelectOptions,
      isFetchingTolls,
      periodsFormConfig,
      isInitialLoad
    ]
  )

  const capacitiesColumns: DataTableColumn[] = [
    {
      name: 'actions',
      label: '',
      hideForResponsive: true,
      type: DataType.HTML,
      columnWidth: 65
    },
    {
      name: 'code',
      type: DataType.TEXT,
      label: t('contracts:components.capacitiesTable.columns.code')
    },
    {
      name: 'type',
      label: t('contracts:components.capacitiesTable.columns.contractCapacityType'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(
        EnumTipoProductoCapacidad,
        'enums:EnumTipoProductoCapacidad'
      )
    },
    {
      name: 'contractType',
      label: t('contracts:components.capacitiesTable.columns.contractType'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumServicio, 'enums:EnumServicio')
    },
    {
      name: 'toll',
      label: t('contracts:components.capacitiesTable.columns.toll'),
      type: DataType.SELECT,
      selectOptions: tollSelectOptions
    },
    {
      name: 'qaEstimada',
      label: t('contracts:components.capacitiesTable.columns.qaEstimada', {
        unit: t('contracts:forms.add.units.kWh')
      }),
      type: DataType.NUMBER,
      customDecimalScale: 0
    },
    {
      name: 'qdContratada',
      label: t('contracts:components.capacitiesTable.columns.qdContratada', {
        unit: t('contracts:forms.add.units.kWh')
      }),
      type: DataType.NUMBER
    },
    {
      name: 'startDate',
      label: t('contracts:components.capacitiesTable.columns.startDate'),
      type: DataType.DATE
    },
    {
      name: 'endDate',
      label: t('contracts:components.capacitiesTable.columns.endDate'),
      type: DataType.DATE
    },
    {
      name: 'status',
      label: t('contracts:components.capacitiesTable.columns.status'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(
        EnumEstadoProductoCapacidad,
        'enums:EnumEstadoProductoCapacidad'
      )
    },
    {
      name: 'canRequestCapacityMod',
      display: false
    },
    {
      name: 'canTerminateCapacity',
      display: false
    }
  ]

  const handleClickDelete = (capacity: CapacityFormModel) => {
    if (!capacity.delete) {
      getInformationSave(
        () =>
          capacity &&
          capacities &&
          setCapacities(removeOrMarkProductTempList(capacities, capacity, false)),
        InformationDialogs.PENDING_DELETE
      )
    } else {
      // If it's already marked as to delete, unmark it
      setCapacities(prevState =>
        prevState.map(c =>
          c.id === capacity.id ? { ...capacity, delete: false, canEdit: true } : c
        )
      )
    }
  }

  const handleCapacityModRequest = (row: CapacityFormModel) => {
    // If there is a pending modification request for this capacity, show the information dialog and return early
    // This prevents the user from initiating another modification request while one is already pending response from distributor.
    if (capacities.find(c => c?.status === EnumEstadoProductoCapacidad.PendienteModificacion)) {
      getInformation(InformationDialogs.PENDING_MOD_REQUEST).then(() => {
        closeInformation()
      })
      return
    }

    history.push(NonAuthRoutes.ContractCapacities, {
      rowCapacity: {
        ...contractCapacitiesMapper(row, contractDetails, cups),
        status: EnumEstadoProductoCapacidad.Borrador // status is forced to Borrador when updating a Capacity
      },
      clientID: clientData?.id,
      clientLinkText: `Cliente ${getLinkClientText(clientData as SubjectProps)} - ID ${clientData?.documentID}`,
      contractId: contract?.id,
      contractCode: contract?.contractCode,
      tollSelectOptionList: defineTollSelectOptionList(pressureGroup)
    })
  }

  const handleCapacityTermination = (rowCapacity: CapacityFormModel) => {
    history.push(NonAuthRoutes.ProceduresAdd, {
      contractId: contract?.id,
      capacityCode: rowCapacity.code,
      formMode: ProcedureFormMode.BAJA_CONTRATO_GAS
    })
  }

  const tableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    customInsertEditModal: true,
    sortOrder: { name: 'endDate', direction: SortDirection.DESC },
    analytics: {
      customer: getCustomerDomain(),
      view: t('contracts:components.capacitiesTable.analytics')
    },
    canDelete: false,
    canEdit: false,
    canInsert: hasPermission(Resources.Client, [UserPermission.EDIT]),
    onRowInsert: async () => {
      onAddCapacityClickHandler()
      return true
    },
    // fabDisabled: !contractData?.cupsId && contractData?.type === EnumTipoContrato.ClienteFinal,
    // fabDisabledTooltipLabel: t('contracts:components.productsTable.fabDisabledTooltip'),
    // fabLabel: t('contracts:components.productsTable.fab'),
    rowCustomActions: [
      {
        userPermission: UserPermission.EDIT,
        icon: <Edit fontSize="small" />,
        visibleIf: 'canEdit',
        tooltip: t('contracts:components.capacitiesTable.actions.edit.title'),
        onClick: (capacity: CapacityFormModel) => onEditCapacityClickHandler(capacity)
      },
      {
        userPermission: UserPermission.EDIT,
        icon: <Delete fontSize="small" />,
        visibleIf: 'canEdit',
        tooltip: t('contracts:components.capacitiesTable.actions.remove.title'),
        onClick: handleClickDelete
      },
      {
        userPermission: UserPermission.EDIT,
        icon: <Delete fontSize="small" />,
        visibleIf: 'delete',
        tooltip: t('contracts:components.capacitiesTable.actions.undoRemove.title'),
        onClick: handleClickDelete
      }
    ]
  }

  if (hasResource(Resources.ComunicationsCenterProcedures)) {
    tableOptions.rowCustomActions?.push(
      {
        userPermission: UserPermission.EDIT,
        icon: <AssignmentLate fontSize="small" />,
        visibleIf: 'canRequestCapacityMod',
        tooltip: t('contracts:components.capacitiesTable.actions.contractCapacities.title'),
        onClick: handleCapacityModRequest
      },
      {
        userPermission: UserPermission.EDIT,
        icon: <Block fontSize="small" />,
        visibleIf: 'canTerminateCapacity',
        tooltip: t('contracts:components.capacitiesTable.actions.contractTermination.title'),
        onClick: handleCapacityTermination
      }
    )
  }

  const cupsOptions: FormOptions = useMemo(() => {
    return {
      columns: 3,
      analytics: {
        customer: getCustomerDomain(),
        view: t('contracts:forms.details.analyticsCups')
      }
    }
  }, [t, getCustomerDomain, isInitialLoad])

  const contractATROptions: FormOptions = useMemo(() => {
    return {
      columns: 3,
      analytics: {
        customer: getCustomerDomain(),
        view: t('contracts:forms.details.analyticsATR')
      }
    }
  }, [t, getCustomerDomain, isInitialLoad])

  const CupsSupplies = ({ isFetching }) => {
    if (isFetching) {
      return <FormSkeleton columns={3} inputs={6} elevation={0} withTitle={true} />
    }

    const contractCommodity = enumEnumToValueNumber(EnumCommodity, contract.commodity)

    if (contractCommodity === EnumCommodity.Electricidad) {
      return (
        <>
          <Paper style={{ paddingBottom: '10px' }}>
            <Form
              title={t('contracts:forms.details.titles.contractATR', {
                version: contractATR?.version
              })}
              sections={contractATRSection}
              data={currentATR}
              options={contractATROptions}
            />
            <Grid
              container
              spacing={2}
              direction="row"
              justify="flex-end"
              style={{
                paddingRight: '20px'
              }}
            >
              <Grid item>
                <Button
                  variant="text"
                  color="primary"
                  size="small"
                  // disabled={}
                  onClick={() => {
                    setShowVersionsTable(prevState => !prevState)
                  }}
                >
                  {showVersionsTable
                    ? t('contracts:forms.details.actions.hideVersionManagement')
                    : t('contracts:forms.details.actions.versionManagement')}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </>
      )
    }

    if (contractCommodity === EnumCommodity.GasNatural) {
      return (
        <div style={{ marginLeft: 'auto', marginRight: 'auto' }}>
          <Card>
            <CardHeader title={t('contracts:components.capacitiesTable.title')}></CardHeader>
            <CardContent>
              <DataTable
                data={capacities}
                columns={capacitiesColumns}
                options={tableOptions}
                // info={DataTableErrorHandler({
                //   errorCode: isFetchingProductsError ? true : undefined,
                //   onRefresh: async () => {
                //     contractID && fetchProductsByContract(contractID)
                //   }
                // })}
                userPermissions={getUserPermissions(Pages.Client)}
              />
            </CardContent>
          </Card>
        </div>
      )
    }

    return null
  }

  useEffect(() => {
    getDetails(contractID)
  }, [])

  useEffect(() => {
    updateFormDefinition(capacityEditDefinition)
  }, [capacityEditDefinition])

  useEffect(() => {
    updateFormDefinition(capacityAddDefinition)
  }, [capacityAddDefinition])

  useEffect(() => {
    updateFormDefinition(tollAndServiceDefinition)
  }, [tollAndServiceDefinition])

  useEffect(() => {
    updateFormDefinition(atrVersionFormDefinition, getFormData('ADD_ATR'))
  }, [atrVersionFormDefinition])

  const atrVersionFormDefinitionRef = useRef(atrVersionFormDefinition)
  useEffect(() => {
    atrVersionFormDefinitionRef.current = atrVersionFormDefinition
  }, [atrVersionFormDefinition])

  useEffect(() => {
    showVersionsTable
      ? window.requestAnimationFrame(() =>
          tableCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
        )
      : window.requestAnimationFrame(() =>
          cupsSuppliesFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
        )
  }, [showVersionsTable])

  //Form config Ends

  return (
    <Page
      notification={globalNotification}
      fullWidth={false}
      layout={PageLayout.SINGLE_COLUMN}
      error={errorProps}
    >
      <PageHeader title={t('contracts:titleDetails')}>
        <Button
          variant="text"
          color="primary"
          size="small"
          disabled={isSaving}
          onClick={() => {
            history.goBack()
          }}
        >
          {t('contracts:buttonsAdd.cancel')}
        </Button>
        <ButtonWithPermissions
          variant="contained"
          color="primary"
          size="small"
          disabled={isFetching || isSaving || validations.isDirty || !pendingChanges}
          hasPermission={hasPermission(Resources.Client, [UserPermission.EDIT])}
          onClick={onSave}
        >
          {t('contracts:buttonsAdd.save')}
        </ButtonWithPermissions>
      </PageHeader>
      <Box mb={1}>
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          {clientData && (
            <BreadcrumbLink
              toPathName="/client/file"
              state={{ clientID: clientData?.id }}
              confirmation={pendingChanges}
            >
              {`Cliente ${getLinkClientText(clientData)} - ID ${clientData.documentID}`}
            </BreadcrumbLink>
          )}
          <Typography key="3" color="primary" variant="subtitle2">
            {t('contracts:breadcrumbs.contract', { contractCode: contract?.contractCode })}
          </Typography>
          <Typography key="3" color="primary" variant="subtitle1">
            {t('contracts:breadcrumbs.details')}
          </Typography>
        </Breadcrumbs>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={6}>
            {!isFetching ? (
              <Form
                title={t('contracts:forms.details.titles.cups')}
                sections={cupsSection}
                data={cups}
                options={cupsOptions}
              />
            ) : (
              <FormSkeleton columns={3} inputs={6} elevation={2} withTitle={true} />
            )}
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={6}>
            <div ref={cupsSuppliesFormRef}>
              <CupsSupplies isFetching={isFetching} />
            </div>
          </Paper>
          <div key="versionsTableCard" style={{ marginTop: '20px' }}>
            {showVersionsTable && atrVersions && atrVersions.length > 0 && (
              <div ref={tableCardRef}>
                <VersionsTable
                  ref={tableCardRef}
                  versions={atrVersions || []}
                  onInsertHandler={onAddAtrVersionHandler}
                  onEditHandler={onEditAtrVersionHandler}
                  onDeleteHandler={onDeleteAtrVersionHandler}
                  onCreateProcedureHandler={onCreateProcedureHandler}
                  canInsert={canInsertVersion}
                />
              </div>
            )}
          </div>
        </Grid>
      </Grid>
      <CustomFormDialog
        maxWidth={formHookProps?.definition?.id === 'DELETE' ? 'xs' : undefined}
        {...formProps}
      ></CustomFormDialog>
    </Page>
  )
}
